import { IAction } from '../../interfaces/interfaces';

//Default values
let defaultValues:any = {
    lock: "tool",
    lockTypeDisabled: false,
}

export const reduxUnitCabinet = (state = defaultValues = {}, action: IAction) => {
  if (action.type === 'UPDATE_UNITCABINET') {
    return action.newState ? Object.assign({}, state, action.newState) : {};
  }
  return state;
};
